<template>
  <div>
    <slot :exit="confirm" />

    <ConfirmationDialog
      :confirm-text="$t('ida.btn.exit')"
      :action-function="exit"
      data-testid="exit-confirm-dialog"
      :show-dialog="exitConfirm"
      :text="$t('customerCart.p.confirmExit')"
      :title="$t('header.selectionConfirmation')"
      emit-close-on-escape
      @close="exitConfirm = false"
    />
  </div>
</template>

<script lang="ts" setup>
import { useCartStore } from '~/stores/cart'
import ConfirmationDialog from '~/components/base/ConfirmationDialog.vue'

const cartStore = useCartStore()

const exitConfirm = ref(false)
const confirm = () => {
  exitConfirm.value = true
}
const exit = () => {
  cartStore.exitSharedCart()
}
</script>

<style lang='scss' scoped>
</style>
